<template>
    <div>
        <b-table
            :fields="fields"
            :items="bankData"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--headed']"
            :busy="loading"
            :thead-class="bankData && bankData.length ? '': 'd-none'"
            show-empty
            table-busy>
            <template #empty="">
                <EmptyState>
                    <template v-slot:image>
                        <img src="/static/img/empty-states/empty-state-cost.png">
                    </template>
                    <template v-slot:title>
                        {{ $gettext('We couldn\'t find any transactions') }}
                    </template>
                    <template v-slot:content>
                        {{ $gettext('Try refreshing the transaction list, or choosing a different account or filters.') }}
                    </template>
                    <template v-slot:cta>
                    <GekkoButton 
                        :text="$gettext('Go to banks')"
                        icon="fa-solid fa-building-columns"
                        :to="{ name: 'Bank' }" 
                    />
                    </template>
                </EmptyState>
            </template>
            <template #head(label)>{{ labelColText }}</template>
            <template #cell(cashflow)="row">{{ formatNumber(row.value) }}</template>
            <template #cell(delta)="row">{{ formatNumber(row.value) }}</template>
        </b-table>
    </div>
</template>

<script>
import EmptyState from "@/components/ui/EmptyState"
import GekkoButton from "@/components/GekkoButton"

export default {
    name: 'CashFlowTable',
    components: {EmptyState, GekkoButton},
    props: {
        bankData: {
            type: Array,
            default: () => []
        },
        labelColText: {
            type: String,
            default: () => ''
        },
        loading: {
            type: Boolean,
            default: () => false
        }
    },
    data() {
        return {
            fields: [
                {key: 'label', label: ''},
                {key: 'cashflow', label: this.$gettext('balance'), thClass: 'text-right', tdClass: 'text-right'},
                {key: 'delta', label: this.$gettext('Cash flow'), thClass: 'text-right', tdClass: 'text-right'}
            ]
        }
    },
    methods: {
        formatNumber(num) {
            num = parseInt(num.toFixed(0))
            let str = num.toLocaleString('en-US')
            return `€ ${str}`
        }
    }
}
</script>